export default __webpack_public_path__ + "static/media/check_blue_new.5c265ce3.svg";